export default __webpack_public_path__ + "static/media/Kaveri Menoki.7d6aec04.jpg";